import { useCallback } from 'react';

import { Tasks } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { type GetBaseMetadata, type LibraryDeletionTask } from '~/store/tasks/types';
import { useCreateTask } from '~/utils/taskUtils/useCreateTask';

export type CreateDeleteLibraryTaskParams = GetBaseMetadata<LibraryDeletionTask>;

export const useCreateDeleteLibraryTask = () => {
  const { createTask } = useCreateTask();
  const { currentWorkspace } = useCurrentWorkspace();

  const createDeleteLibraryTask = useCallback(
    async ({ libraryId }: CreateDeleteLibraryTaskParams) => {
      const workspaceId = currentWorkspace?.id;
      if (!workspaceId) {
        throw new Error('No workspace id');
      }

      return createTask({
        task: {
          metadata: {
            libraryId,
          },
          type: 'LibraryDeletion',
          workspaceId,
        },
        createTask: () =>
          Tasks.createTask({
            workspaceId,
            task: {
              type: 'ContentRemover',
              args: {
                libraryId,
              },
            },
          }),
      });
    },
    [createTask, currentWorkspace?.id],
  );

  return {
    createDeleteLibraryTask,
  };
};
